import { Pipe, PipeTransform, Sanitizer, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'textFormat'
})
export class TextFormatPipe implements PipeTransform {


  constructor(
    private sanitizer: DomSanitizer
  ) { }

  transform(value: string, delimiters: string): any {
    return this.sanitize(this.bold(value, delimiters));
  }

  bold(str, delimiters) {
    return str.replace(new RegExp(delimiters + "(.*)" + delimiters, "ig"), "<strong>$1</strong>")
  }

  sanitize(str) {
    return this.sanitizer.sanitize(SecurityContext.HTML, str);
  }
}
